import { __assign } from "tslib";
import { createHttpTestKit } from '../../http/test-kit';
import { createTeamPerformanceInsightsApi } from './';
import { createFakePostResponder } from '../../test-utils';
export var createTeamPerformanceInsightsApiTestkit = function (parent) {
    if (parent === void 0) { parent = 'localhost'; }
    var fakeHttp = createHttpTestKit();
    var api = createTeamPerformanceInsightsApi(parent, fakeHttp);
    var base = parent + "/analytics/team";
    var handler = {
        whenGetOverview: createFakePostResponder(fakeHttp, base + "/overview"),
        whenGetMyOverview: createFakePostResponder(fakeHttp, base + "/me"),
        whenGetNumberOfRepliesCounts: createFakePostResponder(fakeHttp, base + "/numberOfReplies/counts"),
        whenGetNumberOfRepliesHistogram: createFakePostResponder(fakeHttp, base + "/numberOfReplies/histogram"),
        whenGetSolvedTicketsCounts: createFakePostResponder(fakeHttp, base + "/solvedTickets/counts"),
        whenGetSolvedTicketsHistogram: createFakePostResponder(fakeHttp, base + "/solvedTickets/histogram"),
        whenGetCallVolumeCounts: createFakePostResponder(fakeHttp, base + "/callVolume/counts"),
        whenGetCallVolumeHistogram: createFakePostResponder(fakeHttp, base + "/callVolume/histogram"),
        whenGetHandleTimeCounts: createFakePostResponder(fakeHttp, base + "/handleTime/counts"),
        whenGetHandleTimeHistogram: createFakePostResponder(fakeHttp, base + "/handleTime/histogram"),
        whenGetAssistedCallsCounts: createFakePostResponder(fakeHttp, base + "/assistedCalls/counts"),
        whenGetAssistedCallsHistogram: createFakePostResponder(fakeHttp, base + "/assistedCalls/histogram"),
        whenGetNewPublishedArticlesCounts: createFakePostResponder(fakeHttp, base + "/newPublishedArticles/counts"),
        whenGetNewPublishedArticlesHistogram: createFakePostResponder(fakeHttp, base + "/newPublishedArticles/histogram"),
        whenGetArticleUpdatesCounts: createFakePostResponder(fakeHttp, base + "/articleUpdates/counts"),
        whenGetArticleUpdatesHistogram: createFakePostResponder(fakeHttp, base + "/articleUpdates/histogram"),
        whengetAgentsTable: createFakePostResponder(fakeHttp, base + "/overviewTables/agents"),
        whengetGroupsTable: createFakePostResponder(fakeHttp, base + "/overviewTables/groups"),
        whenGetSatisfactionScoreHistogram: createFakePostResponder(fakeHttp, base + "/satisfactionScore/histogram"),
        whenGetSatisfactionScoreCumulative: createFakePostResponder(fakeHttp, base + "/satisfactionScore/cumulative"),
    };
    return __assign(__assign({}, api), handler);
};
//# sourceMappingURL=testkit.js.map